/**
 * Theme Requirements Aggregation for Repli Sandbox
 * 
 * Extends the base avneue-no-vendor theme requirements with Repli Sandbox specific
 * component requirements.
 */

import type { ComponentRequirements } from '@vibesites/tokens';
import { componentRequirements as baseRequirements } from '@vibesites/theme-avneue-no-vendor/requirements';

/**
 * Repli Sandbox component requirement overrides.
 * Add requirements for any override components here.
 */
const replisandboxOverrides: Record<string, ComponentRequirements> = {
  // Example:
  // Footer: FooterRequirements,
};

/**
 * All component requirements for the Repli Sandbox theme.
 * Inherits from avneue-no-vendor theme and overrides with Repli Sandbox components.
 */
export const componentRequirements: Record<string, ComponentRequirements> = {
  ...baseRequirements,
  ...replisandboxOverrides,
};

/**
 * Get requirements for a specific component.
 */
export function getComponentRequirements(componentName: string): ComponentRequirements | undefined {
  return componentRequirements[componentName];
}

/**
 * Get all component names that have requirements defined.
 */
export function getRegisteredComponentNames(): string[] {
  return Object.keys(componentRequirements);
}
